import { render } from "./LegVolumesCalculatorModal.vue?vue&type=template&id=0b2ed378&scoped=true&ts=true"
import script from "./LegVolumesCalculatorModal.vue?vue&type=script&lang=ts"
export * from "./LegVolumesCalculatorModal.vue?vue&type=script&lang=ts"

import "./LegVolumesCalculatorModal.vue?vue&type=style&index=0&id=0b2ed378&scoped=true&lang=css"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2ed378"]])

export default __exports__